<template>
  <div class="section-container">
    <holidays />
  </div>
</template>

<script>
import Holidays from '@/components/resources/Holidays'
import { freshdeskMixin } from '@/mixins/Freshdesk'

export default {
  mounted() {
    // this.showAndPrefillFreshdesk({})
  },
  components: {
    Holidays
  },
  mixins: [freshdeskMixin]
}
</script>
